import React from 'react';
import { Container, Paper } from '@mui/material';
import PasswordRecoveryForm from './PasswordRecoveryForm';
export default function ForgotPassword() {
  return <Container maxWidth="xs" sx={{ py: 4 }}><Paper variant="outlined" sx={{ p: 3, borderRadius: 3 }}><PasswordRecoveryForm /></Paper></Container>;
}
